import React, { Component } from 'react';
import styled from 'styled-components'
import Header from './../../Resources/AppScreens/CommonComponents/Hospitality/Header.svg';
import _Custom0 from './../../Resources/AppScreens/CommonComponents/Hospitality/Discover Serenity Now.svg';

import _Custom1 from './../../Resources/AppScreens/CommonComponents/Hospitality/Label.svg';
import Custom2 from './../../Resources/AppScreens/CommonComponents/Hospitality/Find My Way.svg';
import  Custom3 from './../../Resources/AppScreens/CommonComponents/Hospitality/Two Buttons.svg';
//import { ReactComponent as Custom4 } from './../../Resources/AppScreens/CommonComponents/Hospitality/Property Resources.svg';
import Footer from './../../Resources/AppScreens/CommonComponents/Hospitality/Bottom Navigation.svg';
import HospitalityComponents from './../../Resources/AppScreens/Preview-Features/Hospitality';

import {Container, ScrollableContent as _ScrollableContent} from './Common';

const Custom0 = styled.img.attrs({src: _Custom0})`
    margin-left: 0;
    margin-right: 0;
`;
const Custom1 = styled.img.attrs({src: _Custom1})`
    align-self: flex-start;
    margin: 13px 0px 13px 13px;
    flex-shrink: 0;
`;

const ScrollableContent = styled(_ScrollableContent)`
    margin-top: 5px;
    gap: 5px;
    padding: 0px;
    &>* {
        flex-shrink: 0;
    }
    
    @media (min-width: 768px) and (max-width: 1025px) {
        &>* {
            margin: 5px 8px 0px 8px;
            width: calc(100% - 16px);
        }
        ${Custom0}{
            margin-left: 0;
            margin-right: 0;
            width: 100%;
        }
        ${Custom1}{
            width: 65%;
        }
    }

`;

const HospitalityPreview = ({ features }) => (<Container>
    <img src={Header} style={{width: "100%"} } />
    <ScrollableContent>
        <Custom0 />
        <Custom1 />
        <img src={Custom2} />
        <img src={Custom3} />
        {features && features.map(feature => HospitalityComponents[feature])}
    </ScrollableContent>
    <img src={Footer} style={{ marginBottom: "0px;", marginTop: "auto", width: "100%" }} />
</Container>);

export default HospitalityPreview;

